import { LOADING, SUCCESS, ERROR } from '../dispatchTypes';

export const initialPasswordResetState = {
  isLoading: false,
  isError: false,
  isSuccess: false,
  errorMessage: '',
};

const passwordResetReducer = (state, action) => {
  switch (action.type) {
    case LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
      };
    }
    case ERROR: {
      return {
        ...state,
        isLoading: false,
        isError: true,
        isSuccess: false,
        errorMessage: action.errorMessage,
      };
    }
    default:
      return initialPasswordResetState;
  }
};

export default passwordResetReducer;
